import Link from 'next/link';
import { localePath, type Locale } from '@ai-radar/shared';
import type { Dictionary } from '@/lib/dictionary';

export function SiteFooter({ locale, dict }: { locale: Locale; dict: Dictionary }) {
  return (
    <div className="page">
      <footer className="site-footer">
        <nav className="footer-links" aria-label={dict.footer.about}>
          <Link href={localePath('/about', locale)}>{dict.footer.about}</Link>
          <Link href={localePath('/privacy', locale)}>{locale === 'ar' ? 'الخصوصية' : 'Privacy'}</Link>
          <Link href={localePath('/delete-account', locale)}>
            {locale === 'ar' ? 'حذف الحساب' : 'Delete account'}
          </Link>
          <Link href={localePath('/about#method', locale)}>{dict.footer.methodology}</Link>
          <a href={localePath('/rss.xml', locale)}>{dict.footer.rss}</a>
          <Link href={localePath('/about#contact', locale)}>{dict.footer.contact}</Link>
        </nav>
        <p className="footer-promise">{dict.footer.promise}</p>
      </footer>
    </div>
  );
}
